import err from './err';
import user from './user';
import sys from './sys';
import group from './group';

const req = {
  err,
  user,
  sys,
  group,
};

export default req;
